'use strict'
import urls from './Urls'
import axios from 'axios'

export const CHILD_API_ENDPOINTS = {
  SEARCH: 'searchPerson',
  GET: 'get',
  SAVE: 'save',
  DELETE: 'delete',
  ADDRESS_LIST: 'address/list',
  ADDRESS_SAVE: 'address/save',
  ADDRESS_REMOVE: 'address/remove',
  ORG_LIST: 'org/list',
  ORG_GET: 'org/get',
  ORG_SAVE: 'org/save',
  ORG_DELETE: 'org/delete',
  ORG_TITLE_LIST: 'org/title/list',
  ORG_TITLE_SAVE: 'org/title/save',
  ORG_TITLE_REMOVE: 'org/title/remove',
  COACH_SPORT_DATES_LIST: 'org/coach/list',
  COACH_SPORT_DATES_SAVE: 'org/coach/save',
  COACH_SPORT_DATES_REMOVE: 'org/coach/remove',
  COMMITTEE_LIST: 'committee/list',
  MERGE_PERSONS: 'merge'
}

function getPersonLookupApiEndPoint () {
  return urls.commonDataApiController() + '/' + CHILD_API_ENDPOINTS.SEARCH
}

function getPersonLookupEndPoint () {
  return urls.personLookupController()
}

function getPersonAdminEditEndPoint (personId) {
  if (personId) {
    return urls.memberPersonAdminController() + '?id=' + personId
  } else {
    return urls.memberPersonAdminController()
  }
}

function getPersonApiEndPoint (personId) {
  let paramStr = '?personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.GET + paramStr
}

function savePersonApiEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.SAVE
}

function deletePersonApiEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.DELETE
}

function getPersonOrgApiEndPoint (orgId, personId) {
  let paramStr = '?orgId=' + orgId + '&personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_GET + paramStr
}

function savePersonOrgApiEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_SAVE
}

function deletePersonOrgApiEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_DELETE
}

// Person Address End Points
function getAddressListEndPoint (personId) {
  let paramStr = '?personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_LIST + paramStr
}

function savePersonAddressEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_SAVE
}

function removePersonAddressEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ADDRESS_REMOVE
}

function getPersonOrgListApiEndPoint (personId) {
  let paramStr = '?personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_LIST + paramStr
}

function getPersonOrgTitleListApiEndPoint (personId, orgId) {
  let paramStr = '?orgId=' + orgId + '&personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_TITLE_LIST + paramStr
}

function savePersonOrgTitleEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_TITLE_SAVE
}

function removePersonOrgTitleEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.ORG_TITLE_REMOVE
}

function getCoachSportDatesListApiEndPoint (personId, orgId) {
  let paramStr = '?orgId=' + orgId + '&personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.COACH_SPORT_DATES_LIST + paramStr
}

function saveCoachSportDatesEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.COACH_SPORT_DATES_SAVE
}

function removeCoachSportDatesEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.COACH_SPORT_DATES_REMOVE
}

function getCommitteeListApiEndPoint (personId) {
  let paramStr = '?personId=' + personId

  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.COMMITTEE_LIST + paramStr
}

function mergePersonsApiEndPoint () {
  return urls.memberPersonAdminApiController() + '/' + CHILD_API_ENDPOINTS.MERGE_PERSONS
}

// Person Lookup API Request
function searchPerson (query, cancelSource) {
  return axios.get(getPersonLookupApiEndPoint(), {
    params: {
      'q': query
    },
    cancelToken: cancelSource.token
  })
}

// Load Person record
function loadPerson (personId) {
  return axios.get(getPersonApiEndPoint(personId))
}

function loadPersonOrg (orgId, personId) {
  return axios.get(getPersonOrgApiEndPoint(orgId, personId))
}

function loadPersonOrgList (personId) {
  return axios.get(getPersonOrgListApiEndPoint(personId))
}

function savePerson (person) {
  return axios.post(savePersonApiEndPoint(), person)
}

function deletePerson (personId) {
  return axios.post(deletePersonApiEndPoint(), {'personId': personId})
}

function savePersonOrg (personOrg) {
  return axios.post(savePersonOrgApiEndPoint(), personOrg)
}

function deletePersonOrg (pk) {
  return axios.post(deletePersonOrgApiEndPoint(), pk)
}

function loadCommitteeList (personId) {
  return axios.get(getCommitteeListApiEndPoint(personId))
}

function mergePersons (data) {
  return axios.post(mergePersonsApiEndPoint(), data)
}

function loadAddresses (personId) {
  return axios.get(getAddressListEndPoint(personId))
}

export default {
  searchPerson: searchPerson,
  getPersonAdminEditEndPoint: getPersonAdminEditEndPoint,
  loadPerson: loadPerson,
  getAddressListEndPoint: getAddressListEndPoint,
  savePersonAddressEndPoint: savePersonAddressEndPoint,
  removePersonAddressEndPoint: removePersonAddressEndPoint,
  loadAddresses: loadAddresses,
  getPersonOrgListApiEndPoint: getPersonOrgListApiEndPoint,
  loadPersonOrg: loadPersonOrg,
  loadPersonOrgList: loadPersonOrgList,
  savePersonOrgTitleEndPoint: savePersonOrgTitleEndPoint,
  removePersonOrgTitleEndPoint: removePersonOrgTitleEndPoint,
  getPersonOrgTitleListApiEndPoint: getPersonOrgTitleListApiEndPoint,
  getCoachSportDatesListApiEndPoint: getCoachSportDatesListApiEndPoint,
  saveCoachSportDatesEndPoint: saveCoachSportDatesEndPoint,
  removeCoachSportDatesEndPoint: removeCoachSportDatesEndPoint,
  savePerson: savePerson,
  savePersonOrg: savePersonOrg,
  deletePersonOrg: deletePersonOrg,
  deletePerson: deletePerson,
  getPersonLookupEndPoint: getPersonLookupEndPoint,
  loadCommitteeList: loadCommitteeList,
  mergePersons: mergePersons
}
